import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Encabezado } from '../../Components/Encabezado/Encabezado';

import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';

import { HiMiniLockClosed, HiMiniLockOpen } from 'react-icons/hi2';
import { IoAddCircle } from 'react-icons/io5';
import { MdDeleteForever, MdEdit, MdOutlineRestaurantMenu } from 'react-icons/md';

import Loading from '../../Components/Modals/Loading/Loader';

import {
  fetchCambiarEstadoSemanaAlmuerzo,
  fetchCambiarSuccess,
  fetchDeleteSemanaAlmuerzo,
  fetchGetCountSemanas,
  fetchGetSemanasAlmuerzoWithPagination,
  selectCountSemanasAlmuerzo,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
  selectSemanasAlmuerzoWithPagination,
} from '../../redux/Cafeteria/CafeteriaSlice';

import moment from 'moment';
import swal from 'sweetalert';
import { AddOrUpdateModal } from '../../Components/Cafetería/Semana/Modals/AddOrUpdateModal';

export const SemanasAlmuerzo = () => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-NAVIGATE
  const navigate = useNavigate();

  // ? HOOK-SELECTOR
  const semanasAlmuerzo = useSelector(selectSemanasAlmuerzoWithPagination);
  const countSemanas = useSelector(selectCountSemanasAlmuerzo);
  const isLoading = useSelector(selectIsLoading);
  const success = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);

  // ? USE-STATE PARA LA PAGINACION
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [skipRow, setSkipRow] = useState(0);

  // ? HOOK-STATE PARA EL MODAL.
  const [open, setOpen] = useState({ data: {}, enable: false });

  // * FUNCIONES PARA PAGINACION.
  const handleChangePage = (event, newPage) => {
    setSkipRow(newPage * rowsPerPage);
    setPage(newPage);
  };

  // * FUNCION PARA REFRESCAR LAS LISTAS
  const refreshAll = () => {
    dispatch(fetchGetSemanasAlmuerzoWithPagination({ index: skipRow, itemsPerPage: rowsPerPage }));
    dispatch(fetchGetCountSemanas());
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setSkipRow(0);
  };

  // ? HOOK-EFFECT
  useEffect(() => {
    refreshAll();
  }, [page, rowsPerPage, skipRow]);

  // ? HOOK-EFFECT PARA SWEET-ALERT
  useEffect(() => {
    if (success === 'success' && message.length > 0) {
      swal('Exitoso!', message, 'success', {
        timer: 2000,
      });

      dispatch(fetchCambiarSuccess());

      // * REFRESCAR TODAS LAS LISTAS NUEVAMENTE.
      refreshAll();
    } else if (success === 'error') {
      swal('Error', message, 'error', {
        timer: 5000,
      });

      dispatch(fetchCambiarSuccess());
    }
  }, [success]);

  // * ACCIONES PARA LAS SEMANAS.
  const funcCambiarEstadoSemana = (semana) => {
    const { id, activo } = semana;

    swal({
      title: 'Confirmación',
      text: activo ? 'Estás seguro/a que desea cerrar esta semana de almuerzo?' : 'Estás seguro/a que desea reabrir esta semana de almuerzo?',
      icon: 'warning',
      buttons: ['No', 'Si'],
    }).then((respuesta) => {
      if (respuesta) {
        dispatch(fetchCambiarEstadoSemanaAlmuerzo(id));
      }
    });
  };

  const funcEliminarSemana = (semana) => {
    const { id, semanaLabel } = semana;

    swal({
      title: 'Confirmación',
      text: `Estás seguro/a que desea eliminar la ${semanaLabel}?`,
      icon: 'warning',
      buttons: ['No', 'Si'],
    }).then((respuesta) => {
      if (respuesta) {
        dispatch(fetchDeleteSemanaAlmuerzo(id));
      }
    });
  };

  return (
    <Encabezado title="Semanas de Almuerzo">
      <div className="d-flex justify-content-end">
        <button className="btn btn-primary-mem" onClick={() => setOpen({ data: {}, enable: true })}>
          Crear Nueva Semana <IoAddCircle style={{ marginBottom: 4 }} fontSize="22" />
        </button>
      </div>

      <Box sx={{ mt: 3 }} maxWidth={'100%'}>
        <Paper sx={{ mb: 2 }} elevation={3}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">Fecha Inicio</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight="bold">Fecha Fin</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight="bold" align="center">
                      Estado
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography fontWeight="bold" align="center">
                      Menú
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography fontWeight="bold">Acciones</Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {semanasAlmuerzo?.length > 0 ? (
                  semanasAlmuerzo.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{moment(item.fechaInicio).format('DD/MM/yyyy')}</TableCell>
                      <TableCell>{moment(item.fechaTermino).format('DD/MM/yyyy')}</TableCell>
                      <TableCell align="center">
                        <Typography textTransform="uppercase" fontWeight="bold" color={item.activo ? 'green' : 'grey'}>
                          {item.activo ? 'Activo' : 'Inactivo'}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <button className="btn btn-primary-mem" onClick={() => navigate('/cafeteria/registro/menuSemanal', { state: item.id })}>
                          Agregar Menú <MdOutlineRestaurantMenu fontSize={22} />
                        </button>
                      </TableCell>
                      <TableCell align="center">
                        <div className="d-flex justify-content-center">
                          <IconButton onClick={() => setOpen({ data: item, enable: true })}>
                            <MdEdit color="#003876" />
                          </IconButton>
                          {!item.empleadoMenuSemanaSeleccionado ? (
                            <IconButton onClick={() => funcEliminarSemana(item)}>
                              <MdDeleteForever color="red" />
                            </IconButton>
                          ) : (
                            <></>
                          )}
                          {item.activo ? (
                            <IconButton onClick={() => funcCambiarEstadoSemana(item)}>
                              <HiMiniLockClosed color="#003876" />
                            </IconButton>
                          ) : (
                            <IconButton>
                              <HiMiniLockOpen onClick={() => funcCambiarEstadoSemana(item)} color="green" />
                            </IconButton>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableCell align="center" colSpan={6}>
                    <Typography>No existen semanas registradas.</Typography>
                  </TableCell>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={countSemanas}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>

      <Loading open={isLoading} />

      <AddOrUpdateModal open={open} setOpen={setOpen} />
    </Encabezado>
  );
};
